import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { PageTrackerService } from './services/page-tracker.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'web-app';

  ngOnInit() {
    this.authService.restoreSessionFromLocalStorage();
  }
  constructor(private trackingService: PageTrackerService, private authService: AuthService) {
    this.trackingService.startTracking();
  }
}
